import AssociationPersonalInformation from './AssociationPersonalInformation.page';

export default AssociationPersonalInformation;